export default __webpack_public_path__ + "static/media/wallet04.45040deb.png";